// Mağaza ortak parçaları — website store/index.php + data.php yardımcılarının React karşılıkları.
import React, { useCallback, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { Link } from "react-router-dom";
import { storeFiyat, storeIndirim, saticiAdi, konumAdi } from "../storeData";
import { kategorilerGetir } from "../storeApi";
import CheckBox from "../../../components/CheckBox/CheckBox";
import Dropdown from "../../../components/Dropdown/Dropdown";

export const STORE_BASE = "/store";
export const storePath = (p = "") => (p ? `${STORE_BASE}/${String(p).replace(/^\//, "")}` : STORE_BASE);

const IKON_YOLLARI = {
  sofa: (
    <>
      <path d="M4 11V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3" />
      <path d="M2 11h20v6H2z" />
      <path d="M5 17v2M19 17v2" />
    </>
  ),
  fridge: (
    <>
      <rect x="6" y="2" width="12" height="20" rx="2" />
      <path d="M6 10h12M9 6v2M9 13v3" />
    </>
  ),
  tv: (
    <>
      <rect x="2" y="4" width="20" height="13" rx="2" />
      <path d="M8 21h8M12 17v4" />
    </>
  ),
  rug: (
    <>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M3 9h18M3 15h18" />
    </>
  ),
  lamp: (
    <>
      <path d="M9 3h6l3 7H6l3-7z" />
      <path d="M12 10v8M9 21h6" />
    </>
  ),
  tree: (
    <>
      <path d="M12 2l5 8h-3l4 6H6l4-6H7l5-8z" />
      <path d="M12 16v6" />
    </>
  ),
  box: (
    <>
      <path d="M3 7l9-4 9 4v10l-9 4-9-4V7z" />
      <path d="M3 7l9 4 9-4M12 11v10" />
    </>
  ),
  // Ofis: ofis koltuğu · Depo & Lojistik: depo binası + raf · Spor: dambıl (website storeIkon ile aynı)
  office: (
    <>
      <rect x="7" y="3" width="10" height="8" rx="2" />
      <path d="M5 11h14v2H5z" />
      <path d="M5 11V9M19 11V9" />
      <path d="M12 13v4" />
      <path d="M7.5 21 12 17l4.5 4" />
    </>
  ),
  warehouse: (
    <>
      <path d="M3 21V9l9-5 9 5v12" />
      <path d="M7 21v-8h10v8" />
      <path d="M7 17h10" />
      <path d="M10 13v8M14 13v8" />
    </>
  ),
  dumbbell: (
    <>
      <path d="M7 12h10" />
      <rect x="4" y="7" width="3" height="10" rx="1" />
      <rect x="17" y="7" width="3" height="10" rx="1" />
      <path d="M2 10v4M22 10v4" />
    </>
  ),
  grid: (
    <>
      <rect x="3" y="3" width="7" height="7" rx="1.5" />
      <rect x="14" y="3" width="7" height="7" rx="1.5" />
      <rect x="3" y="14" width="7" height="7" rx="1.5" />
      <rect x="14" y="14" width="7" height="7" rx="1.5" />
    </>
  ),
};

/** Kategori kutucuklarının çizgi ikonları (storeIkon). */
export function StoreIcon({ name }) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" strokeLinecap="round" strokeLinejoin="round">
      {IKON_YOLLARI[name] || IKON_YOLLARI.box}
    </svg>
  );
}

/** Ürün kartı — ızgaralarda tek kaynak (storeKart). Kapak görseli tam görünür (object-fit: cover). */
export function ProductCard({ u }) {
  const ind = storeIndirim(u);
  const lot = u.kategori === "depodan-toplu-satis";
  const bas = String(u.ad || "").charAt(0);
  return (
    <Link
      className="st-card"
      to={storePath(`urun/${u.slug}`)}
      data-fiyat={Math.round(u.fiyat)}
      data-durum={u.durum}
      data-depo={konumAdi(u)}
      data-satici={u.saticiTipi}
      data-ad={String(u.ad || "").toLocaleLowerCase("tr-TR")}
    >
      <div className={`st-card__ph${u.kapak ? " has-img" : ""}`} aria-hidden="true">
        {u.kapak ? <img src={u.kapak} alt="" loading="lazy" decoding="async" /> : bas}
        <span className="st-card__chips">
          {u.rozet ? <span className={`st-card__rozet${lot ? " st-card__rozet--lot" : ""}`}>{u.rozet}</span> : null}
          <span className="st-card__durum">{u.durum}</span>
        </span>
        {ind > 0 ? <span className="st-card__ind">%{ind}</span> : null}
      </div>
      <div className="st-card__body">
        {u.marka ? <span className="st-card__marka">{u.marka}</span> : null}
        <span className="st-card__ad">{u.ad}</span>
        <span className="st-card__teslim">
          {u.saticiTipi === "troy" ? <strong>Troy Depo</strong> : saticiAdi(u)} · {konumAdi(u)}
        </span>
        <span className="st-card__fiyat">
          <span className="st-card__yeni">{storeFiyat(u.fiyat)}</span>
          {u.eskiFiyat ? <span className="st-card__eski">{storeFiyat(u.eskiFiyat)}</span> : null}
        </span>
      </div>
    </Link>
  );
}

/**
 * Overlay'ler (modal, lightbox, çekmece) için portal. Mağaza kökü container query
 * kabı olduğundan position:fixed öğeler onun DIŞINA, body'ye taşınır; tokenlar ve
 * font için yine .store-root sınıfı taşır (container olmadan: .store-portal).
 */
export function StorePortal({ children }) {
  if (typeof document === "undefined") return null;
  return createPortal(<div className="store-root store-portal">{children}</div>, document.body);
}

/** Kart markası logosu (storeKartMarka). */
export function CardBrand({ marka, buyuk = false }) {
  const sinif = `st-brand st-brand--${String(marka || "").replace(/[^a-z]/g, "")}${buyuk ? " st-brand--lg" : ""}`;
  if (marka === "visa") {
    return (
      <span className={sinif}>
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path
            fill="#1434CB"
            d="M9.112 8.262L5.97 15.758H3.92L2.374 9.775c-.094-.368-.175-.503-.46-.658C1.447 8.864.677 8.627 0 8.479l.046-.217h3.3a.904.904 0 0 1 .894.764l.817 4.338 2.018-5.102zm8.033 5.049c.008-1.979-2.736-2.088-2.717-2.972.006-.269.262-.555.822-.628a3.66 3.66 0 0 1 1.913.336l.34-1.59a5.207 5.207 0 0 0-1.814-.333c-1.917 0-3.266 1.02-3.278 2.479-.012 1.079.963 1.68 1.698 2.04.756.367 1.01.603 1.006.931-.005.504-.602.725-1.16.734-.975.015-1.54-.263-1.992-.473l-.351 1.642c.453.208 1.289.39 2.156.398 2.037 0 3.37-1.006 3.377-2.565zm5.061 2.447H24l-1.565-7.496h-1.656a.883.883 0 0 0-.826.55l-2.909 6.946h2.036l.405-1.12h2.488zm-2.163-2.656l1.02-2.815.588 2.815zm-8.144-4.84l-1.603 7.496H8.34l1.604-7.496z"
          />
        </svg>
      </span>
    );
  }
  if (marka === "mastercard" || marka === "maestro") {
    const ikinci = marka === "mastercard" ? "#F79E1B" : "#0099DF";
    const orta = marka === "mastercard" ? "#FF5F00" : "#6C6BBD";
    return (
      <span className={sinif}>
        <svg viewBox="0 0 40 24" aria-hidden="true">
          <circle cx="15" cy="12" r="8.2" fill="#EB001B" />
          <circle cx="25" cy="12" r="8.2" fill={ikinci} />
          <path fill={orta} d="M20 5.4a8.2 8.2 0 0 1 0 13.2 8.2 8.2 0 0 1 0-13.2Z" />
        </svg>
      </span>
    );
  }
  if (marka === "amex") {
    return (
      <span className={sinif}>
        <svg viewBox="0 0 40 24" aria-hidden="true">
          <rect width="40" height="24" rx="3" fill="#1F72CD" />
          <text
            x="20"
            y="15.5"
            textAnchor="middle"
            fontFamily="Arial,Helvetica,sans-serif"
            fontSize="8.5"
            fontWeight="700"
            letterSpacing="0.5"
            fill="#fff"
          >
            AMEX
          </text>
        </svg>
      </span>
    );
  }
  if (marka === "troy") {
    return (
      <span className={sinif}>
        <svg viewBox="0 0 40 24" aria-hidden="true">
          <text
            x="2"
            y="17"
            fontFamily="Arial,Helvetica,sans-serif"
            fontSize="13"
            fontWeight="800"
            fontStyle="italic"
            letterSpacing="-0.5"
            fill="#00AEEF"
          >
            troy
          </text>
        </svg>
      </span>
    );
  }
  return <span className={sinif}>KART</span>;
}

/** Breadcrumb: items = [{label, to?}] — son öğe link değildir. */
export function Crumb({ items }) {
  return (
    <nav className="st-crumb">
      <Link to={STORE_BASE}>Mağaza</Link>
      {items.map((it, i) => (
        <React.Fragment key={i}>
          <span>›</span>
          {it.to ? <Link to={it.to}>{it.label}</Link> : it.label}
        </React.Fragment>
      ))}
    </nav>
  );
}

/**
 * Canlı TCKN alanı (storeTcknAlani + storeTcknScript). Kontrol kuralları storeData.tcknHata.
 * Ebeveyn `zorla` true verirse (gönderimde) boş/eksik değer de hata olarak gösterilir.
 */
export { default as TcknField } from "./TcknField";

/* ── Veri yükleme yardımcıları ── */

/**
 * Asenkron yükleme: yukle() → {ok, ...} döndüren fonksiyon. deps değişince yeniden çalışır.
 * Dönüş: [durum {yukleniyor, veri, hata}, tazele]. Bileşen kalkınca sonucu yazmaz.
 */
export function useYukle(yukle, deps) {
  const [durum, setDurum] = useState({ yukleniyor: true, veri: null, hata: "" });
  const sayac = useRef(0);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const calistir = useCallback(yukle, deps);
  const tazele = useCallback(
    (sessiz = false) => {
      const no = ++sayac.current;
      if (!sessiz) setDurum((d) => ({ ...d, yukleniyor: true, hata: "" }));
      return Promise.resolve(calistir()).then(
        (r) => {
          if (no !== sayac.current) return;
          setDurum({ yukleniyor: false, veri: r && r.ok ? r : null, hata: r && r.ok ? "" : (r && r.mesaj) || "Veriler alınamadı." });
        },
        () => {
          if (no !== sayac.current) return;
          setDurum({ yukleniyor: false, veri: null, hata: "Veriler alınamadı." });
        },
      );
    },
    [calistir],
  );
  useEffect(() => {
    tazele();
    const s = sayac;
    return () => {
      s.current++; // bekleyen sonuç artık yazılmasın
    };
  }, [tazele]);
  return [durum, tazele];
}

/** Kategori ağacı (API, önbellekli): {yukleniyor, kategoriler, hata}. */
export function useKategoriler() {
  const [d] = useYukle(() => kategorilerGetir(), []);
  return { yukleniyor: d.yukleniyor, kategoriler: d.veri ? d.veri.liste : [], hata: d.hata };
}

/** Yükleniyor / hata kutusu (st-bos düzeni). */
export function Durum({ yukleniyor, hata, onTekrar, style }) {
  if (yukleniyor) {
    return (
      <div className="st-bos st-yukleniyor" style={style} role="status" aria-live="polite">
        <p>Yükleniyor…</p>
      </div>
    );
  }
  if (hata) {
    return (
      <div className="st-bos" style={style} role="alert">
        <h3>Bir sorun oluştu</h3>
        <p>
          {hata}{" "}
          {onTekrar ? (
            <button type="button" className="st-link-btn" onClick={() => onTekrar()}>
              Tekrar dene
            </button>
          ) : null}
        </p>
      </div>
    );
  }
  return null;
}

/**
 * Onay kutusu: paneldeki CheckBox yalnız görsel; tıklanabilir/klavyeyle seçilebilir sarmalayıcı
 * (PromoCodesPage "Secim" deseni). className ile yerleşim sınıfı verilir.
 */
// Mağaza açılır listesi — panelin kendi Dropdown bileşeni (yerel <select> yerine).
// Etiket mağaza alanındaki .st-field__lbl'de durur (Dropdown'un yüzen etiketi kullanılmaz).
// id sarmalayıcıdadır: hata durumunda odak/kaydırma (document.getElementById(id).focus()) çalışır.
// options: [{ value, label }] ya da düz metin dizisi; onChange(değer).
export function StoreSecim({ id, value, onChange, options = [], placeholder = "Seçin", disabled, hatali, describedBy, className = "" }) {
  const liste = options.map((o) => (typeof o === "object" ? o : { value: o, label: o }));
  return (
    <div
      id={id}
      tabIndex={-1}
      className={`st-dd${hatali ? " is-hata" : ""}${className ? ` ${className}` : ""}`}
      aria-describedby={describedBy}
      aria-invalid={hatali ? "true" : "false"}
      // Alan <label> içinde: label tıklamayı düğmeye ikinci kez iletip listeyi kapatmasın
      onClick={(e) => e.preventDefault()}
      onFocus={(e) => {
        // Sarmalayıcıya odak gelince (hata odağı) düğmeye geç
        if (e.target === e.currentTarget) e.currentTarget.querySelector("button")?.focus({ preventScroll: true });
      }}
    >
      <Dropdown
        label=""
        placeholder={placeholder}
        options={liste}
        value={value ?? ""}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}

export function Secim({ isaretli, onDegis, children, className = "", id, describedBy }) {
  return (
    <span
      className={`st-secim${className ? ` ${className}` : ""}`}
      id={id}
      role="checkbox"
      aria-checked={isaretli ? "true" : "false"}
      aria-describedby={describedBy}
      tabIndex={0}
      onClick={() => onDegis(!isaretli)}
      onKeyDown={(e) => {
        if (e.key === " " || e.key === "Enter") {
          e.preventDefault();
          onDegis(!isaretli);
        }
      }}
    >
      <CheckBox isSelected={!!isaretli} />
      <span className="st-secim__ad">{children}</span>
    </span>
  );
}
